var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import CalendarControlled from "./CalendarControlled.js";
import CalendarUncontrolled from "./CalendarUncontrolled.js";
import { CalendarMonthPublic } from "./CalendarMonth.js";
import { CalendarDayPublic } from "./CalendarDay.js";
var Calendar = function (props) {
    var _a = props.firstWeekDay, firstWeekDay = _a === void 0 ? 1 : _a, _b = props.mode, mode = _b === void 0 ? "single" : _b, startDate = props.startDate, endDate = props.endDate;
    var resolvedProps = __assign(__assign({}, props), { firstWeekDay: firstWeekDay, mode: mode, monthsToShow: mode === "double" ? 2 : 1, vertical: mode === "vertical" });
    if (startDate === undefined && endDate === undefined) {
        return (React.createElement(CalendarUncontrolled, __assign({}, resolvedProps)));
    }
    return (React.createElement(CalendarControlled, __assign({}, resolvedProps)));
};
Calendar.Month = CalendarMonthPublic;
Calendar.Day = CalendarDayPublic;
export default Calendar;
